<template>
  <div
    class="basic_map_index"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
  >
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_edit_330')"
        btnIcon="el-icon-magic-stick"
        @changeStyle="changeStyle('animation')"
        v-if="this.$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index" v-if="$store.state.app.view_pattern === 'pc'"></my_close_btn>
    </div>
    <div class="basic_map_wrap" ref="basic_map_wrap">
      <my_title_index :title="widgets_infor.title"></my_title_index>
      <div
        class="map_wrap"
        :style="$store.state.app.view_pattern === 'mb' ? 'padding: 3.2% 3.72%;' : ''"
      >
        <div class="map_wrap_line" :style="{ paddingBottom: `${mapHeight}` }">
          <div ref="map" class="map_container" @mousedown.stop></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import mapMarkerPointImg from '@/assets/image/marker_red_sprite.png'
// import ComplexCustomOverlay from './ComplexCustomOverlay'

export default {
  name: 'basic_map_index',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    listArr () {
      return this.module.data.listArr
    },
    infor () {
      return this.module.data[this.$store.state.app.view_pattern + '_infor']
    },
    widgets_infor () {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    mapHeight () {
      let pc_widgets_infor = this.module.data['pc_widgets_infor']
      let mapHeight = '74.9279%'
      if (this.$store.state.app.view_pattern === 'pc') {
        mapHeight = pc_widgets_infor.size[pc_widgets_infor.size.radio_val].height
      } else {
        mapHeight = '74.9279%'
      }
      return mapHeight;
    }
  },
  watch: {
    'listArr.addressInfo': {
      handler (val) {
        this.myCompOverlay.setContent(val)
      },
      deep: true
    },
    '$store.state.main_dialog.main_dialog_isShow': {
      handler (val, oldVal) {
        if (val) {
          this.map.addEventListener("click", this.click_map_handler)
        } else {
          this.map.removeEventListener("click", this.click_map_handler)
        }
      },
      deep: true
    },
    '$store.state.app.view_pattern': {
      handler (val) {
        setTimeout(() => {
          this.map.panTo(this.listArr.mapPoint)
        }, 600)
      },
      deep: true
    },
    'infor.marginRight' (val) {
      setTimeout(() => {
        this.map.panTo(this.listArr.mapPoint)
      }, 600)
    }
  },
  data () {
    return {
      isHover: false,
      padding: 0,
      map: null,
      local: null,
      mapMarker: null,
      myCompOverlay: null,
      mapMarkerPointImg: mapMarkerPointImg,
      isFirstRender: true
    }
  },
  mounted () {
    return
    this.init_map()
    if (this.listArr.city !== '' && this.listArr.address !== '') {
      this.local.search(this.listArr.city + this.listArr.address)
    }
    $(window).on('resize', this.debounce(() => {
      setTimeout(() => {
        this.map.panTo(this.listArr.mapPoint)
      }, 600)
    }))
  },
  methods: {
    module_isHover (val) {
      this.isHover = val
    },
    changeStyle (tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    init_map () {
      const _this = this
      this.map = new BMap.Map(this.$refs.map, { enableMapClick: true })
      this.map.centerAndZoom(new BMap.Point(121.458217, 31.306394), 18)
      this.map.addControl(new BMap.NavigationControl())
      this.map.addEventListener("dblclick", function () {
        _this.changeStyle('style')
      })
      // 标注
      let myIcon = new BMap.Icon(_this.mapMarkerPointImg, new BMap.Size(22, 25))
      this.mapMarker = new BMap.Marker(new BMap.Point(121.458217, 31.306394), { icon: myIcon })
      this.map.addOverlay(_this.mapMarker)
      // 自定义覆盖物
      this.myCompOverlay = new ComplexCustomOverlay(new BMap.Point(121.458217, 31.306394), this.listArr.addressInfo)
      this.map.addOverlay(this.myCompOverlay)
      this.mapMarker.addEventListener("click", function (point) {
        _this.myCompOverlay.show()
      })
      // 将地址解析结果显示在地图上,并调整地图视野
      this.local = new BMap.LocalSearch(this.map, {
        onSearchComplete (results) {
          _this.$message.closeAll()
          // 判断状态是否正确
          if (_this.local.getStatus() == BMAP_STATUS_SUCCESS) {
            let res = results.getPoi(0)
            let point = res.point
            _this.move_marker(point)
            let addressInfo = i18n.t('widgets_basic_map_index_2593', [res.title,res.address])
            if (!_this.isFirstRender && _this.listArr.addressInfo === '-' || _this.listArr.addressInfo === '') {
              _this.listArr.addressInfo = addressInfo
              _this.myCompOverlay.setContent(addressInfo)
              _this.$message.success(i18n.t('widgets_basic_map_index_2594'))
            }
            _this.isFirstRender = false
          } else {
            _this.$message.error(i18n.t('widgets_basic_map_index_2595'))
          }
        }
      })
      this.$store.state.map.local[this.module.widgets_id] = this.local
    },
    move_marker (point) {
      this.listArr.mapPoint = point
      this.mapMarker.setPosition(point)
      this.map.panTo(point)
      this.myCompOverlay.setPosition(point)
      this.myCompOverlay.show()
    },
    click_map_handler (e) {
      this.move_marker(e.point)
    },
    debounce (fn, time = 500) {
      let timer = null
      return (...args) => {
        clearTimeout(timer)
          timer = setTimeout(() => {
          fn(args)
        }, time)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.basic_map_index {
  height: 100%;
  .tooptipPart {
    right: 0;
    top: 0;
    display: block;
    z-index: 999;
  }
  .title {
    height: 50px;
    line-height: 50px;
  }
  .basic_map_wrap {
    width: 100%;
    .map_container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style lang="scss">
.basic_map_index {
  .basic_map_wrap {
    .map_wrap {
      position: relative;
      .map_wrap_line {
        overflow: hidden;
        position: relative;
        transition: all .3s;
        .map_container {
          position: absolute !important;
          width: 100%;
          height: 100%;
          .msgBox {
            display: inline-block;
            cursor: default;
            position: absolute;
            z-index: 99999;
            width: auto;
            height: auto;
            padding: 18px 21px 18px 12px;
            background-color: #fff;
            border-radius: 6px;
            box-shadow: #000 0 0 6px -3px;
            .msg {
              display: inline-block;
              word-wrap: break-word;
              word-break: break-word;
              font-size: 13px;
              width: 230px;
            }
            .arrow {
              position: absolute;
              display: inline-block;
              bottom: -6px;
              left: 125px;
              width: 0;
              height: 0;
              content: "";
              border-style: solid;
              border-width: 7px;
              border-color: #fff #fff transparent transparent;
              transform: rotate(135deg);
              box-shadow: #000 1px -1px 3px -2px;
            }
            .close {
              cursor: pointer;
              display: block;
              position: absolute;
              right: 5px;
              top: 5px;
              width: 20px;
              height: 20px;
              background: url(~@/assets/image/cssSprite.png) no-repeat -423px -158px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_map/index.vue